import { gql } from '@apollo/client';

export const PROCESS_TRACK_EXPORT_FILE = gql`
  mutation ProcessTrackExportFile($input: ProcessTrackExportFileInput!) {
    processTrackExportFile(input: $input) {
      taskId
      taskNo
      status
      fileName
      message
    }
  }
`;

export interface ProcessTrackExportFileInput {
  objectKey: string;
  fileName: string;
}

export interface ProcessTrackExportFileResponse {
  processTrackExportFile: {
    taskId: number;
    taskNo: string;
    status: number;
    fileName: string;
    message: string;
  };
}
